import { X } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription, SheetClose } from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import CustomerProfilePanel from "@/components/CustomerProfilePanel";

export default function CustomerProfile({ contactId, open, onOpenChange }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      {/* Hide the default low-contrast Sheet close (it sat cramped over the
          dark header) and use a clearly visible circular one instead. */}
      <SheetContent side="left" className="w-full sm:max-w-md p-0 bg-card [&>button.rounded-sm]:hidden">
        <SheetHeader className="sr-only"><SheetTitle>Customer profile</SheetTitle><SheetDescription>CRM details</SheetDescription></SheetHeader>
        <SheetClose
          data-testid="customer-profile-close"
          className="absolute right-3 top-3 z-20 inline-flex h-7 w-7 items-center justify-center rounded-full bg-white/95 text-slate-700 shadow-md ring-1 ring-black/5 transition-all hover:bg-white hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary"
          aria-label="Close"
        >
          <X className="h-3.5 w-3.5" />
        </SheetClose>
        <ScrollArea className="h-screen">
          {contactId && <CustomerProfilePanel contactId={contactId} variant="drawer" />}
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
